<div class="grading-section form-section">
	<div class="form-group grading-form-group" [class.has-error]="shouldDisplayPointsPossibleError()">
		<mat-form-field appearance="outline" class="grading-select-field">
			<mat-label translate="activity-editor-new_grading-and-eval"></mat-label>
			<mat-select
				id="grading-type-dropdown"
				data-cy="grading-type-dropdown"
				[formControl]="gradingTypeControl"
				required>
				<mat-select-trigger>
					<span class="option-title">{{ getSelectedGradingTitle() }}</span>
				</mat-select-trigger>
				@for (option of gradingOptions; track option.key) {
					<mat-option [value]="option.key" [disabled]="isGradingOptionDisabled(option)" [attr.data-cy]="'rd-item-' + option.key.toLowerCase()">
						<div class="grading-option">
							<div class="option-title">
								{{ option.config.title | translate }}
							</div>
							<div class="option-description">
								{{ getGradingOptionDescriptionKey(option) | translate }}
							</div>
						</div>
					</mat-option>
				}
			</mat-select>
			<mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
		</mat-form-field>

		@if (shouldDisplayPointsPossible() && pointsControl) {
			<mat-form-field
				appearance="outline"
				class="points-field"
				[class.readonly]="isPointsPossibleDisabled()">
				<mat-label translate="activity-editor-new_points-possible"></mat-label>
				<input
					matInput
					id="activity-editor-points-possible-input"
					type="number"
					min="0"
					step="0.01"
					data-cy="points-possible-value"
					[formControl]="pointsControl"
					[readonly]="isPointsPossibleDisabled()"
					[matTooltip]="getPointsDisabledTooltip()"
					[matTooltipDisabled]="!isPointsPossibleDisabled()"
					aria-describedby="points-error"
					(blur)="normalizePointsPossible()">
			</mat-form-field>
		}
	</div>
	@if (shouldDisplayPointsPossibleError()) {
		<mat-error id="points-error" translate="activity-editor-new_points-required"></mat-error>
	}

	@if (selectedRubric) {
		<ngx-panel>
			<panel-heading>
				<div class="title ellipsis">
					@if (isLoadingRubric) {
						<span class="ficon-spinner ficon-spin" aria-hidden="true"></span>
					} @else {
						<span translate="rubric_scoring_title"></span>
					}
				</div>

				<ngx-toolbar>
					<ngx-toolbar-button
						[disabled]="isLoadingRubric"
						[action]="toolbarActions.PREVIEW"
						(clicked)="handlePreview()">
					</ngx-toolbar-button>
					<ngx-toolbar-button
						[disabled]="isLoadingRubric"
						[action]="toolbarActions.EDIT"
						(clicked)="handleEdit()">
					</ngx-toolbar-button>
					<ngx-toolbar-button
						[disabled]="isLoadingRubric"
						[action]="toolbarActions.REMOVE"
						(clicked)="handleRemove()">
					</ngx-toolbar-button>
				</ngx-toolbar>
			</panel-heading>

			<panel-body>
				<span>{{ selectedRubric.title || ('common_untitled' | translate) }}</span>

				<!-- Allow Reviewers Access -->
				<section class="reviewers-rubrics-access">
					<div class="reviewers-access">
						<mat-checkbox
							color="primary"
							[formControl]="reviewersAccessControl"
							data-cy="reviewers-rubric-access">
							<span translate="activity-editor_allow-reviewer-access"></span>
						</mat-checkbox>
						<button
							type="button"
							class="ficon-app-help-circle-outline icon-btn"
							[goCdkPopover]="'activity-editor-new_reviewers-rubrics-access-help' | translate"
							[attr.aria-label]="'activity-editor-new_reviewers-rubrics-access-help_aria-label' | translate">
						</button>
					</div>
				</section>
			</panel-body>
		</ngx-panel>
	}
</div>
